<div
  class="menu-layout"
  [class.menu-layout-collapsed]="!expanded"
  [class.can-load-animation]="canLoadAnimation"
>
  <aside class="menu-container">
    <div class="menu-sidebar">
      <div class="menu-sidebar__top">
        <button
          type="button"
          class="menu-toggle"
          (click)="toggleExpand()"
          [attr.aria-label]="expanded ? 'Collapse menu' : 'Expand menu'"
        >
          @if (expanded) {
            <span>−</span>
          }
          @if (!expanded) {
            <span>+</span>
          }
        </button>
      </div>

      <div class="menu-sidebar__body">
        <div class="menu-list">
          @for (item of menuItems; track item) {
            <a
              class="menu-item"
              [routerLink]="item.url"
              routerLinkActive="menu-item-selected"
            >
              @if (!expanded) {

              <span class="menu-item-icon-wrap">
                <app-icon
                  class="menu-item-icon"
                  [name]="item.icon"
                  [alt]="(prefixLabel + item.title) | translate"
                  [title]="(prefixLabel + item.title) | translate"
                ></app-icon>
              </span>
              }

              @else {
                <span class="menu-item-name">
                  {{ (prefixLabel + item.title) | translate }}
                </span>
              }
            </a>
          }
        </div>
      </div>

      <div class="menu-sidebar__bottom">
        <a
          class="menu-item menu-item--configurator"
          routerLink="/catalog-list"
          routerLinkActive="menu-item-selected"
        >
          @if (!expanded) {
            <span class="menu-item-icon-wrap">
            <app-icon
              class="menu-item-icon"
              name="icon-ipe-configurator"
              [alt]="'crm.menu.crm.menu.crm.configurator' | translate"
            ></app-icon>
          </span>
          }
          @else {
            <span class="menu-item-name">
              {{ (prefixLabel + 'CONFIGURATOR') | translate }}
            </span>
          }
        </a>
      </div>
    </div>
  </aside>

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
